import { useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { getIntegrationAppLabel } from 'helpers';
import { IntegrationApp, useIntegration_GetIntegrationsByPortalIdQuery } from 'queries';

import Spinner from 'common/spinner';

import { useStyles } from './integrations-import-list.styles';

type Props = {
  setShowIntegrationSyncModal: (integrationApp: IntegrationApp) => void;
};

export const IntegrationsImportList = ({ setShowIntegrationSyncModal }: Props) => {
  const classes = useStyles();

  const { portalId } = useParams<Record<string, string>>();

  const { data: integrationData, loading: integrationDataLoading } =
    useIntegration_GetIntegrationsByPortalIdQuery({
      variables: {
        input: {
          portalId: portalId,
        },
      },
      fetchPolicy: 'no-cache',
      nextFetchPolicy: 'no-cache',
    });

  const getEnabledIntegrationButtons = () => {
    return integrationData?.data?.map((integration) => {
      return (
        <Button
          key={integration.id}
          variant="contained"
          onClick={() => setShowIntegrationSyncModal(integration.app)}
        >
          Sync {getIntegrationAppLabel(integration.app)}
        </Button>
      );
    });
  };

  if (integrationDataLoading) {
    return <Spinner />;
  }

  return <Box className={classes.container}>{getEnabledIntegrationButtons()}</Box>;
};
